<script>
import AvatarWangYongjun from '@/assets/images/expert-team/user_WangYongjun.jpg'
import AvatarDongQiang from '@/assets/images/expert-team/user_DongQiang.png'
import AvatarWangYiLong from '@/assets/images/expert-team/user_WangYilong.png'
import AvatarFangKun from '@/assets/images/expert-team/user_FangKun.png'
import AvatarLiShujuan from '@/assets/images/expert-team/user_LiShujuan.png'
import AvatarTanZefeng from '@/assets/images/expert-team/user_TanZehua.png'
import AvatarFanYuhua from '@/assets/images/expert-team/user_FangYuhua.png'
import AvatarLiJingwei from '@/assets/images/expert-team/user_LiJingwei.png'
import AvatarWuBo from '@/assets/images/expert-team/user_WuBo.png'
import AvatarZhouZhenhua from '@/assets/images/expert-team/user_ZhouZhenhua.png'
import AvatarSongBo from '@/assets/images/expert-team/user_SongBo.png'
import AvatarChengXin from '@/assets/images/expert-team/user_ChengXin.png'
import AvatarYinYou from '@/assets/images/expert-team/user_YinYou.png'
import AvatarLiuBo from '@/assets/images/expert-team/user_LiuBo.png'
import AvatarMengGuilin from '@/assets/images/expert-team/user_MengGuilin.png'
import AvatarWangHailin from '@/assets/images/expert-team/user_WangHailin.png'
import videoList from './expert-team-data'

export default {
  name: 'ExpertTeam',
  data: () => ({
    videoList: videoList.reverse(),
    lnExpert: [
      {
        avatar: AvatarWangYongjun,
        name: "王拥军",
        hospitalName: "首都医科大学附属北京天坛医院",
        titleName: ["中国卒中学会会长", "中国卒中学会青年工作委员会主任委员"],
      },
      {
        avatar: AvatarDongQiang,
        name: "董强",
        hospitalName: "复旦大学附属华山医院",
        titleName: ["上海卒中学会会长", "上海卒中学会青年工作委员会名誉主任委员"],
      }
    ],
    executeExpertTeam: [
      {
        avatar: AvatarWangYiLong,
        name: '王伊龙',
        hospitalName: ['首都医科大学附属北京天坛医院'],
        titleName: ['中国卒中学会青年工作委员会常务副主委', '中国卒中学会脑小血管病分会副主任委员']
      },
      {
        avatar: AvatarFangKun,
        name: '方堃',
        hospitalName: ['复旦大学附属华山医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '上海卒中学会青年工作委员会主任委员']
      },
      {
        avatar: AvatarLiShujuan,
        name: '李淑娟',
        hospitalName: ['中国医学科学院阜外医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '中国卒中学会医疗质量管理与促进分会副主委']
      },
      {
        avatar: AvatarTanZefeng,
        name: '谭泽锋',
        hospitalName: ['佛山市第一人民医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '广东省卒中学会第一届脑血流与代谢分会常委']
      },
      {
        avatar: AvatarFanYuhua,
        name: '范玉华',
        hospitalName: ['中山大学附属第一医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '中国卒中学会血管性认知障碍分会常务委员']
      },
      {
        avatar: AvatarLiJingwei,
        name: '李敬伟',
        hospitalName: ['南京大学医学院附属苏州医院', '南京大学医学院附属鼓楼医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '江苏省医学会神经病学分会候任主任委员']
      },
      {
        avatar: AvatarWuBo,
        name: '吴波',
        hospitalName: ['四川大学华西医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '世界卒中组织青年委员']
      },
      {
        avatar: AvatarZhouZhenhua,
        name: '周振华',
        hospitalName: ['陆军军医大学第一附属医院'],
        titleName: ['中国卒中学会青年工作委员会副主任委员', '中国医师协会神经内科分会委员']
      },
      {
        avatar: AvatarSongBo,
        name: '宋波',
        hospitalName: ['郑州大学第一附属医院'],
        titleName: ['河南省医学会脑卒中分会副主任委员', '中国卒中学会理事兼河南省卒中学会副会长']
      },
      {
        avatar: AvatarChengXin,
        name: '程忻',
        hospitalName: ['复旦大学附属华山医院'],
        titleName: ['中国卒中学会脑小血管病分会副主委', '卒中防治下基层,青年专家在行动--科研项目负责人']
      },
      {
        avatar: AvatarYinYou,
        name: '尹又',
        hospitalName: ['同济大学附属东方医院'],
        titleName: ['上海卒中学会青年工作委员会副主任委员', '上海市医学会神经病学分会青年副主任委员']
      },
      {
        avatar: AvatarLiuBo,
        name: '刘博',
        hospitalName: ['上海交通大学医学院附属新华医院'],
        titleName: ['中国医师协会心律学专业委员会委员', '上海卒中学会青年工作委员会副主任委员']
      },
      {
        avatar: AvatarMengGuilin,
        name: '孟桂林',
        hospitalName: ['同济大学附属第十人民医院'],
        titleName: ['中国康复学会手功能专委会青年委员', '上海卒中学会青年工作委员会副主任委员']
      },
      {
        avatar: AvatarWangHailin,
        name: '万海林',
        hospitalName: ['复旦大学附属华山医院'],
        titleName: ['上海卒中学会青年工作委员会副主任委员', '第二届中国神经介入医师手术大赛十佳医师']
      },
    ],
    videoVisible: false,
    videoItem: {},
  }),
  computed: {
    executeExpertTeamSwiperData () {
      const chunkSize = 7
      return Array.from(
        { length: Math.ceil(this.executeExpertTeam.length / chunkSize) },
        (_, i) => this.executeExpertTeam.slice(i * chunkSize, i * chunkSize + chunkSize)
      )
    }
  },
  methods: {
    clickCarouselPrev () {
      this.$refs.refElCarousel.prev()
    },
    clickCarouselNext () {
      this.$refs.refElCarousel.next()
    },
    clickVideo (index) {
      const item = this.videoList[index]
      if (item.videoUrl.includes('//mp.weixin.qq.com')) {
        window.open(item.videoUrl)
      } else {
        this.videoVisible = true
        this.videoItem = this.videoList[index]
      }
    }
  }
}
</script>

<template>
  <div class="expert_team">
    <div class="banner_box">
      <img src="@/assets/images/expert-team/banner-back.png" alt="" class="banner_back">
      <div class="banner_box_main">
        <div class="banner">
          <div class="banner_img">
            <img src="@/assets/images/expert-team/banner.png" alt="" class="banner_img__inner">
          </div>
          <div class="banner_content">
            <h1>卒中防治下基层，青年专家在行动</h1>
            <p>我国第三次国民死因调在结果表明，脑血管病已经成为国民的第一位死因。脑卒中严重影响患者生活质量，给家庭 和社会造成巨大负担。脑卒中具有高发病率，高复发率、高致残率、高死亡率、经济负担重。</p>
            <p>当前县域级医疗机构与省级医疗机构仍然存在校大的临床诊疗差距。规范，全程的疾病管理理含亟待提升。上海卒 中学会落实“健康中国2030”指导纲要，计划发起“卒中防治下基层，青年专家在行动“三年行动计划。在中国县域 医院院长联盟的倡议下，联合中国卒中学会中青年专家和上海卒中学会中青年专家通过患者宣教，学术交流，短期 参访等提升县域级医疗机构卒中中心卒中预防与救治的整体服务能力。造福更多基层（县域）地区的广大患者。</p>
            <!-- <p>具体合作事宜请联系项目办公室 <span style="padding: 0 10px;">联系人：沈老师</span> 电话：021-62299150 <a class="link" href="https://richangwenjian-1256680128.cos.ap-beijing.myqcloud.com/%E5%90%88%E4%BD%9C%E5%87%BD%EF%BC%88%E7%BD%91%E7%AB%99%E7%89%88%EF%BC%89.docx" target="_blank">合作函(点击下载)</a></p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="expert_team_title">
        <div>主席介绍</div>
        <div class="line"></div>
      </div>
      <div class="expert_team_card">
        <div class="card_title">联合主席</div>
        <div class="lh_expert">
          <div class="lh_expert_item" v-for="item in lnExpert" :key="item.name">
            <img src="@/assets/images/expert-team/back01.png" alt="" class="back">
            <div class="item_main">
              <div class="item_main_left">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3">
                  <img class="avatar" :src="item.avatar" alt="">
                </div>
              </div>
              <div class="item_main_right">
                <div class="username">{{ item.name }}</div>
                <div class="title_name" v-for="title in item.titleName" :key="title"><strong>·</strong> <span>{{ title }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="expert_team_card">
        <div class="card_title">执行主席团</div>
        <div class="execute_expert_team">
          <div class="arrow_icon left">
            <img class="arrow_icon__inner" @click="clickCarouselPrev" src="@/assets/images/expert-team/icon-arrow-left.png" alt=""  />
          </div>
          <div class="arrow_icon right">
            <img class="arrow_icon__inner" @click="clickCarouselNext" src="@/assets/images/expert-team/icon-arrow-right.png" alt=""  />
          </div>
          <el-carousel ref="refElCarousel" indicator-position="outside" height="400px" :interval="10 * 1000" arrow="never">
            <el-carousel-item v-for="(item, index) in executeExpertTeamSwiperData" :key="`carousel_${ index }`">
              <div class="carousel_item_list">
                <div class="carousel_item_item" v-for="(val, idx) in item" :key="`carousel_${ index }_${ idx }`">
                  <div class="avatar">
                    <img class="avatar__inner" :src="val.avatar" alt="" />
                  </div>
                  <div class="info">
                    <img class="info_back" alt="" src="@/assets/images/expert-team/back02.png" />
                    <div class="info_main">
                      <div class="name">{{ val.name }}</div>
                      <div class="desc" v-for="text in val.hospitalName" :key="text">{{ text }}</div>
                      <div class="desc" v-for="text in val.titleName" :key="text">{{ text }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="expert_team_title" style="padding-top: 80px;">
        <div>视频集锦</div>
        <div class="line"></div>
      </div>
      <div class="expert_team_card">
        <div class="information">
          <div class="content_list">
            <div class="content_item" v-for="(item, index) in videoList" :key="item.videoUrl" @click="clickVideo(index)">
              <div class="main">
                <h3 class="title">{{ item.title }} | {{ item.subTitle }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="`${ videoItem.title } ${ videoItem.subTitle }`"
      :visible.sync="videoVisible"
      width="1300px"
      center
    >
      <div class="expert_team_video" v-if="videoItem">
        <div class="expert_team_video_main">
          <video :src="videoItem.videoUrl" controls class="video__inner"></video>
        </div>
        <div class="expert_team_poster">
          <el-image class="image__inner" :src="videoItem.poster + '?imageMogr2/format/webp'" fit="contain"></el-image>
          <!--<img />-->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">

.expert_team {
  .banner_box {
    position: relative;
    .banner_box_main {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      .banner {
        width: 1160px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .banner_img {
          flex: 0 0 420px;
          width: 420px;
          height: 240px;
        }
        .banner_content {
          background-color: rgba(0, 0, 0, .6);
          color: #FFF;
          height: 240px;
          box-sizing: border-box;
          padding: 24px 20px;
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            padding-bottom: 12px;
          }
          p {
            text-align: justify;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 20px;
            font-style: normal;
            text-transform: none;
            margin-top: 4px;
          }
          a.link {
            padding-left: 10px;
            color: #FFF;
            text-decoration: underline;
          }
        }
      }
    }
  }
  &_title {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #1F2329;
    line-height: 45px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    .line {
      margin-top: 6px;
      width: 50px;
      height: 4px;
      background-color: #2083FA;
    }
  }
  .container {
    width: 1087px;
    margin: 0 auto;
    .expert_team_card {
      & + .expert_team_card { padding-top: 52px; }
      .card_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 26px;
        color: #1F2329;
        line-height: 36px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .lh_expert {
        padding-top: 30px;
        display: flex;
        justify-content: space-between;
        &_item {
          flex: 0 0 534px;
          width: 534px;
          height: 252px;
          position: relative;
          .item_main {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            &_left {
              position: relative;
              flex: 0 0 220px;
              height: 100%;
              .box1 {
                position: absolute;
                left: 33px;
                bottom: 28px;
                z-index: 1;
                width: 158px;
                height: 193px;
                background: #CCD9E8;
                border-radius: 6px ;
              }
              .box2 {
                position: absolute;
                left: 46px;
                bottom: 28px;
                z-index: 2;
                width: 158px;
                height: 224px;
                background: #B6CFF3;
                border-radius: 6px;
              }
              .box3 {
                position: absolute;
                left: 50px;
                bottom: 28px;
                z-index: 3;
                width: 158px;
              }
            }
            &_right {
              flex: auto;
              padding-left: 5px;
              padding-top: 30px;
              .username {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #030303;
                line-height: 25px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                padding-bottom: 10px;
              }
              .title_name {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #1F2329;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                padding-bottom :4px;
                span {
                  padding-left: 5px;
                }
              }
            }
          }
        }
      }
      .execute_expert_team {
        position: relative;
        .arrow_icon {
          position: absolute;
          top: 0;
          z-index: 10;
          display: flex;
          align-items: center;
          height: 350px;
          &.left { left: -74px; }
          &.right { right: -74px; }
          &__inner {
            width: 64px;
            object-fit: contain;
            cursor: pointer;
          }
        }
        .carousel_item_list {
          display: flex;
          .carousel_item_item {
            & + .carousel_item_item { margin-left: 18px; }
            position: relative;
            flex: 0 0 140px;
            width: 140px;
            height: 350px;
            border-radius: 5px 5px 5px 5px;
            box-shadow: 0 5px 10px #ddd;
            .avatar {
              position: absolute;
              top:0;
              left: 0;
              width: 100%;
              z-index: 1;
              &__inner {
                width: 100%;
                object-fit: contain;
              }
            }
            .info {
              position: relative;
              z-index: 2;
              width: 100%;
              padding-bottom: 30px;
              .info_back {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 3;
                width: 100%;
                object-fit: contain;
              }
              .info_main {
                position: relative;
                z-index: 4;
                padding-top: 155px;
                .name {
                  font-family: PingFang SC,serif;
                  font-weight: 500;
                  font-size: 16px;
                  color: #1F2329;
                  line-height: 22px;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                  padding-bottom: 8px;
                }
                .desc {
                  padding: 0 16px;
                  font-family: PingFang SC,serif;
                  font-weight: 400;
                  font-size: 12px;
                  color: #646A73;
                  line-height: 17px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }
            }
          }
        }
      }
      .information {
        padding-bottom: 70px;
        .filter_bar {
          padding: 15px 0 55px;
          display: flex;
          justify-content: center;
          align-items: center;
          .filter_item {
            & + .filter_item { margin-left: 20px; }
            cursor: pointer;
            width: 122px;
            height: 32px;
            background-color: #F7F7F7;
            font-family: PingFang SC,serif;
            font-weight: 400;
            font-size: 16px;
            color: #8F959E;
            line-height: 32px;
            text-align: center;
            transition: all .3s;
            &:hover, &.active {
              background-color: #2285FD;
              color: #FFF;
            }
          }
        }
        .content_list {
          display: grid;
          grid-gap: 20px ;
          grid-template-columns: 1fr 1fr;
          .content_item {
            display: flex;
            padding: 16px;
            background-color: #F6F6F6;
            cursor: pointer;
            transition: all .2s;
            .cover {
              flex: 0 0 190px;
              width: 190px;
              height: 144px;
              &__inner {
                width: 100%;
                height: 100%;
              }
            }
            .main {
              flex: auto;
              padding-left: 16px;
              padding-top: 6px;
              .title {
                font-family: PingFang SC,serif ;
                font-weight: 500;
                font-size: 16px;
                color: #1F2329;
                line-height: 22px;
                text-align: left;
              }
              .desc {
                margin-top: 12px;
                font-family: PingFang SC,serif ;
                font-weight: 400;
                font-size: 12px;
                color: #1F2329;
                line-height: 17px;
                text-align: left;
              }
            }
            &.active, &:hover {
              background-color: #2285FD;
              .main {
                .title,.desc { color: #FFF; }
              }
            }
          }
        }
      }
    }
  }

  .expert_team_video {
    display: flex;
    justify-content: space-between;
    &_main {
      flex: 0 0 774px;
      .video__inner {
        width: 774px;
        height: 436px;
        object-fit: contain;
      }
    }
    .expert_team_poster {
      flex: auto;
      padding-left: 10px;
      overflow: auto;
      height: 436px;
      .image__inner {
        width: 100%;
        min-height: 400px;
        object-fit: contain;
      }
    }
  }
}
</style>

<style lang="scss">

.expert_team {
  .expert_team_video {
    .el-image__error { min-height: 430px; }
  }
  .el-carousel__indicator {
    .el-carousel__button {
      width: 4px;
      height: 4px;
      border-radius: 10px;
      background-color: #AEAEAE;
    }
    &.is-active {
      .el-carousel__button {
        width: 20px;
        background-color: #2083FA;
      }
    }
  }
}
</style>